import { render } from "./vSimpleCheckbox.vue?vue&type=template&id=653d0dd4&scoped=true"
import script from "./vSimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./vSimpleCheckbox.vue?vue&type=script&lang=js"

import "./vSimpleCheckbox.vue?vue&type=style&index=0&id=653d0dd4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653d0dd4"]])

export default __exports__